import React from 'react';

export const BROAD_MATCH = [
  {
    matchType: 'Sample Keyword',
    broad: 'Green squirrel',
    phrase: `"Green squirrel"`,
    exact: `[Green squirrel]`,
  },
  {
    matchType: 'Will match',
    broad: (
      <>
        Green squirrel
        <br />
        Green squirrels
        <br />
        squirrels are great
      </>
    ),
    phrase: (
      <>
        Green squirrel is awesome
        <br />
        White and Green squirrel
      </>
    ),
    exact: 'Green squirrel',
  },
  {
    matchType: 'Won’t match',
    broad: (
      <>
        White elephant
        <br />
        Awesome monkey
      </>
    ),
    phrase: 'Green squirrel',
    exact: 'Green squirrels',
  },
];

export const BROAD_MATCH_LABELS = {
  matchType: 'Match type',
  broad: 'Broad',
  default: 'default',
  phrase: 'Phrase',
  quotes: 'quotes',
  exact: 'Exact',
  brackets: 'brackets',
};
